import React from 'react';
import { OrgSection } from '../../../types/entities';
import { Company } from '../../_shared';
import styles from './Companies.module.scss';

interface Props {
    orgSections: OrgSection[];
}

export const Companies: React.FC<Props> = ({ orgSections }) => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Нам доверяют</h1>
            <div className={styles.content}>
                {orgSections.map((orgSection) => (
                    <div className={styles.item} key={orgSection.id}>
                        <Company orgSection={orgSection} />
                    </div>
                ))}
            </div>
        </div>
    );
};
